function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14.849 9.808L14.142 9.101L4.242 19.001H0V14.758L11.313 3.444L16.97 9.101C17.1575 9.28853 17.2628 9.54283 17.2628 9.808C17.2628 10.0732 17.1575 10.3275 16.97 10.515L9.9 17.586L8.485 16.172L14.849 9.808ZM12.728 7.687L11.313 6.273L2 15.586V17.001H3.414L12.728 7.687ZM15.556 0.615998L18.385 3.444C18.5725 3.63153 18.6778 3.88583 18.6778 4.151C18.6778 4.41616 18.5725 4.67047 18.385 4.858L16.97 6.273L12.728 2.03L14.142 0.615998C14.3295 0.428527 14.5838 0.323212 14.849 0.323212C15.1142 0.323212 15.3685 0.428527 15.556 0.615998Z",
  fill: "#252658"
});

function SvgPen(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.f5be2832035855d671c4fa2f25b10589.svg";
export { ForwardRef as ReactComponent };